export enum ChangeRequestOperationType {
  ProductCreate = "product_create",
  ProductUpdate = "product_update",
  ProductDelete = "product_delete",
  GroupCreate = "group_create",
  GroupUpdate = "group_update",
  GroupDelete = "group_delete",
  ModifierCreate = "modifier_create",
  ModifierUpdate = "modifier_update",
  ModifierDelete = "modifier_delete",
  ModifierGroupCreate = "modifier_group_create",
  ModifierGroupUpdate = "modifier_group_update",
  ModifierGroupDelete = "modifier_group_delete",
  UnitCreate = "unit_create",
  UnitUpdate = "unit_update",
  UnitDelete = "unit_delete",
  PrepStationCreate = "prep_station_create",
  PrepStationUpdate = "prep_station_update",
  PrepStationDelete = "prep_station_delete",
  BookkeepingAccountCreate = "bookkeeping_account_create",
  BookkeepingAccountUpdate = "bookkeeping_account_update",
  BookkeepingAccountDelete = "bookkeeping_account_delete",
  FloorPlanCreate = "floor_plan_create",
  FloorPlanUpdate = "floor_plan_update",
  FloorPlanDelete = "floor_plan_delete",
  LayoutCreate = "layout_create",
  LayoutUpdate = "layout_update",
  LayoutDelete = "layout_delete",
  ProductPageCreate = "product_page_create",
  ProductPageUpdate = "product_page_update",
  ProductPageAddItems = "product_page_add_items",
  ProductPageDelete = "product_page_delete",
  StoreSettingsUpdate = "store_settings_update",
  OnlineOrderSettingsUpdate = "online_order_settings_update",
  DeviceConfigCreate = "device_config_create",
  DeviceConfigUpdate = "device_config_update",
  DeviceConfigDelete = "device_config_delete",
  PaymentMethodCreate = "payment_method_create",
  PaymentMethodUpdate = "payment_method_update",
  PaymentMethodDelete = "payment_method_delete",
  PrinterCreate = "printer_create",
  PrinterUpdate = "printer_update",
  PrinterDelete = "printer_delete",
  CourseCreate = "course_create",
  CourseUpdate = "course_update",
  CourseDelete = "course_delete",
  OfferCreate = "offer_create",
  OfferUpdate = "offer_update",
  OfferDelete = "offer_delete",
  SupplierCreate = "supplier_create",
  SupplierUpdate = "supplier_update",
  SupplierDelete = "supplier_delete",
}
